<!-- =============================================
     Floating Launcher (collapsed state)
     ============================================= -->
@if (!isOpen) {
  <button
    type="button"
    class="chatbot-launcher-btn"
    (click)="toggleChat()"
    aria-label="Open DeepRoots Assistant Chat"
  >
    <!-- Icon -->
    <div class="launcher-icon-wrap">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        ></path>
      </svg>
      <span class="online-dot"></span>
    </div>

    <!-- Label -->
    <span class="launcher-label">DeepRoots Assistant</span>

    <!-- Unread badge -->
    <span class="notif-badge">3</span>
  </button>
}

<!-- =============================================
     Expanded Chat Window
     ============================================= -->
@if (isOpen) {
  <div class="chatbot-window" [class.maximized]="isMaximized">
    <!-- ── Header ── -->
    <div class="chatbot-header">
      <div class="header-left">
        <!-- Bot avatar -->
        <div class="header-avatar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="11" width="18" height="10" rx="2" />
            <circle cx="12" cy="5" r="2" />
            <path d="M12 7v4" />
            <line x1="8" y1="16" x2="8.01" y2="16" />
            <line x1="16" y1="16" x2="16.01" y2="16" />
          </svg>
          <span class="header-status-dot"></span>
        </div>

        <!-- Name & status -->
        <div class="header-meta">
          <h4 class="header-name">DeepRoots Assistant</h4>
          <span class="header-status">
            <span class="status-online">Online</span>
          </span>
        </div>
      </div>

      <!-- Header Action Buttons (Maximize & Minimize) -->
      <div class="header-actions">
        <button
          type="button"
          class="icon-btn"
          (click)="toggleMaximize($event)"
          [title]="isMaximized ? 'Restore View' : 'Maximize View'"
          [attr.aria-label]="isMaximized ? 'Restore view' : 'Maximize view'"
        >
          @if (!isMaximized) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
              />
            </svg>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M4 14h6v6m10-10h-6V4m0 6l7-7M3 21l7-7" />
            </svg>
          }
        </button>

        <button
          type="button"
          class="icon-btn"
          (click)="minimizeChat($event)"
          title="Minimize"
          aria-label="Minimize chat"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      </div>
    </div>

    <!-- ── Body ── -->
    <div class="chatbot-body">
      <!-- Date divider -->
      <div class="date-divider">
        <span>Today</span>
      </div>

      <!-- Messages -->
      <div class="messages-stream">
        @for (msg of messages; track msg.id) {
          <div
            class="chat-row"
            [class.user-row]="msg.sender === 'user'"
            [class.bot-row]="msg.sender === 'bot'"
          >
            <!-- Bot avatar (left) -->
            @if (msg.sender === "bot") {
              <div class="row-avatar bot-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="3" y="11" width="18" height="10" rx="2" />
                  <circle cx="12" cy="5" r="2" />
                  <path d="M12 7v4" />
                  <line x1="8" y1="16" x2="8.01" y2="16" />
                  <line x1="16" y1="16" x2="16.01" y2="16" />
                </svg>
              </div>
            }

            <!-- Bubble + timestamp -->
            <div class="bubble-wrap">
              <div class="msg-bubble">
                <!-- Plain text -->
                @if (msg.text) {
                  <p>{{ msg.text }}</p>
                }

                <!-- Loan type chips -->
                @if (msg.loanTypes && msg.loanTypes.length > 0) {
                  <div class="chip-grid">
                    @for (type of msg.loanTypes; track type) {
                      <div class="chip">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="11"
                          height="11"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="chip-icon"
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        <span>{{ type }}</span>
                      </div>
                    }
                  </div>
                }

                <!-- Lender cards -->
                @if (msg.lenders && msg.lenders.length > 0) {
                  <div class="lenders-list">
                    @for (lender of msg.lenders; track lender) {
                      <div class="lender-card">
                        <div class="lender-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M3 21h18" />
                            <path d="M3 10h18" />
                            <path d="M5 6l7-3 7 3" />
                            <path d="M4 10v11" />
                            <path d="M20 10v11" />
                            <path d="M8 10v11" />
                            <path d="M12 10v11" />
                            <path d="M16 10v11" />
                          </svg>
                        </div>
                        <div class="lender-info">
                          <span class="lender-name">{{ lender }}</span>
                          <span class="lender-sub"
                            >NC Qualified Lender • $25k–$100k</span
                          >
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- Solar products -->
                @if (msg.solarProducts && msg.solarProducts.length > 0) {
                  <div class="solar-section">
                    <span class="section-label">Recommended Products</span>
                    <div class="solar-cards">
                      @for (prod of msg.solarProducts; track prod.title) {
                        <div class="solar-card">
                          <span class="solar-title">{{ prod.title }}</span>
                          <span class="solar-desc">{{ prod.desc }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }

                <!-- Solar requirements -->
                @if (
                  msg.solarRequirements && msg.solarRequirements.length > 0
                ) {
                  <div class="solar-section">
                    <span class="section-label">Key Requirements</span>
                    <div class="chip-grid">
                      @for (req of msg.solarRequirements; track req) {
                        <div class="chip req">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="11"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="chip-icon"
                          >
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg>
                          <span>{{ req }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              <span class="msg-time">{{ msg.timestamp }}</span>
            </div>

            <!-- User avatar (right) -->
            @if (msg.sender === "user") {
              <div class="row-avatar user-avatar">
                <span>You</span>
              </div>
            }
          </div>
        }

        <!-- Typing indicator -->
        @if (isTyping) {
          <div class="chat-row bot-row">
            <div class="row-avatar bot-avatar">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="11" width="18" height="10" rx="2" />
                <circle cx="12" cy="5" r="2" />
                <path d="M12 7v4" />
              </svg>
            </div>
            <div class="bubble-wrap">
              <div class="typing-bubble">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ── Footer ── -->
    <div class="chatbot-footer">
      <div class="input-row">
        <input
          type="text"
          class="chat-input"
          placeholder="Type a message or question…"
          [(ngModel)]="userInputValue"
          (keyup.enter)="onSendMock()"
          aria-label="Chat message input"
        />
        <button
          type="button"
          class="send-btn"
          [disabled]="!userInputValue.trim()"
          (click)="onSendMock()"
          aria-label="Send message"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </button>
      </div>
      <div class="footer-caption">
        <span>Mockup Chat Assistant</span>
      </div>
    </div>
  </div>
}
